import React from "react";
import { BookOpenIcon, ClipboardCheckIcon, MapIcon, NotebookPenIcon, CalendarDaysIcon, GiftIcon, ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
const recap = [{
  icon: BookOpenIcon,
  text: "Six premium digital volumes"
}, {
  icon: ClipboardCheckIcon,
  text: "Ready-to-use educational protocols and checklists"
}, {
  icon: MapIcon,
  text: "Visual concept maps and reference materials"
}, {
  icon: NotebookPenIcon,
  text: "Practical worksheets and learning templates"
}, {
  icon: CalendarDaysIcon,
  text: "A structured 30-day study roadmap"
}, {
  icon: GiftIcon,
  text: "Five exclusive bonus collections"
}, {
  icon: ShieldCheckIcon,
  text: "A 7-day money-back guarantee"
}];
export function FinalCta() {
  return <section className="w-full bg-forestDark px-4 py-16 text-white sm:py-20" data-id="element-150" data-mp="2z3n13r05iyoq">
      <div className="mx-auto max-w-3xl text-center" data-id="element-151" data-mp="3437vrp8agkvn">
        <h2 className="font-serif text-[30px] font-bold leading-[1.15] sm:text-5xl" data-id="element-152" data-mp="342ptobyy3cft">
          Ready to Organize Your <em className="text-goldSoft" data-id="element-153" data-mp="27aaqjqeg9ke">Biomagnetism Studies?</em>
        </h2>
        <p className="mt-4 text-[17px] leading-relaxed text-white/80" data-id="element-154" data-mp="3temsazv72p0u">
          You don't have to spend hours creating your own templates, organizing every document manually, or rebuilding your study plan from scratch.
        </p>
        <ul className="mx-auto mt-8 grid max-w-xl gap-3 text-left" data-id="element-155" data-mp="71xzmjpbf5zi">
          {recap.map(({
          icon: I,
          text
        }) => <li key={text} className="flex items-center gap-3 rounded-xl bg-white/[0.07] px-4 py-3 text-[16px] font-medium" data-id="element-156" data-mp="3agjy86nsi1w6">
              <I className="h-5 w-5 shrink-0 text-goldSoft" aria-hidden="true" data-id="element-157" data-mp="3ogus7ikebwlk" /> {text}
            </li>)}
        </ul>
        <p className="mt-8 text-[18px] text-white/85" data-id="element-158" data-mp="3jggoudtqpatv">
          All for a one-time payment of just <strong className="text-goldSoft" data-id="element-159" data-mp="13oswkvpo86he">$27</strong>.
        </p>
        <p className="mt-2 text-[13px] font-bold uppercase tracking-[0.14em] text-white/60" data-id="element-160" data-mp="yr9fzp5i3hma">Your ready-made learning system is waiting</p>
        <div className="mt-6" data-id="element-161" data-mp="3si7mpgs5w7bl">
          <CtaButton label="Yes! I want instant access for $27" data-id="element-162" data-mp="3slbv6qcntp82" />
          <p className="mt-3 text-[13px] text-white/70" data-id="element-163" data-mp="1bd96jg9tadm">$27 USD · One-time payment · Instant digital access · Lifetime access · 7-day guarantee</p>
        </div>
        <Countdown tone="dark" data-id="element-164" data-mp="ad4e3m2zld6f" />
      </div>
    </section>;
}